import { withTranslation } from 'react-i18next';
import { Component } from 'react';
import ShowAllItemsModal from './ShowAllItemsModal';
import DomainImage from '../../../../components/DomainImage';

class Competitors extends Component {
    constructor(props) {
        super(props);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);

        this.onClickShowAll = this.onClickShowAll.bind(this);
        this.state = {
            showLess: props.data.length > 3,
            isOpenModal: false,
        };
    }

    onClickShowAll = () => {
        this.setState({ showLess: false });
    };

    onOpenModal() {
        this.setState({ isOpenModal: true });
    }

    onCloseModal() {
        this.setState({ isOpenModal: false });
    }

    generateView(domain) {
        return (
            <div className="d-flex align-items-center gap-8">
                <DomainImage domain_name={domain} className="domain_img" /> {domain}
            </div>
        );
    }

    render() {
        const { t } = this.props;
        const { showLess } = this.state;

        const firstOnes = this.props.data.slice(0, 3);
        const data = showLess ? firstOnes : this.props.data;

        return (
            <>
                <div className={'ai-tracking-prompts-items'}>
                    {data.map((item) => (
                        <div key={item.domain} className={'ai-tracking-projects-platforms'}>
                            <div className="ai-tracking-project-keywords">
                                <DomainImage domain_name={item.domain} className="domain_img" />{' '}
                                {item.domain}
                            </div>
                        </div>
                    ))}
                    {showLess && (
                        <div className="ai-tracking-platform-show-more" onClick={this.onOpenModal}>
                            + {this.props.data?.length - firstOnes.length}
                        </div>
                    )}
                </div>
                {this.state.isOpenModal && (
                    <ShowAllItemsModal
                        isOpen={this.state.isOpenModal}
                        onClose={this.onCloseModal}
                        data={this.props.data?.map((item) => ({
                            view: this.generateView(item.domain),
                            name: item.domain,
                        }))}
                        placeholder={t('ai_tracking.global.search_competitors')}
                    />
                )}
            </>
        );
    }
}

export default withTranslation()(Competitors);
